import { createChannel } from "APP_ROOT/cable";
import api from "APP_ROOT/api";
import { isEmpty } from "lodash";
import * as actionTypes from "./actionTypes";

let RELEASE_ID = "";

export function checkForUpgrade(releaseId) {
  return dispatch => {
    dispatch({
      type: actionTypes.UPGRADE_CHECK,
      upgradeAvailable:
        releaseId && releaseId !== RELEASE_ID && !isEmpty(RELEASE_ID)
    });
  };
}

export function subscribe() {
  api.session.tenant().then(response => {
    RELEASE_ID = response.headers["x-release-id"];
  });
  return dispatch =>
    createChannel().listen("UpgradeChannel", {
      onReceive: data => {
        dispatch({
          type: actionTypes.UPGRADE_CHECK,
          upgradeAvailable:
            !isEmpty(RELEASE_ID) &&
            data.release_id &&
            data.release_id !== RELEASE_ID
        });
      }
    });
}



// WEBPACK FOOTER //
// ./app/modules/Upgrade/actions.js